import React, { useState } from "react"
import { Col } from "components/base/Col/Col"
import { Row } from "components/base/Row/Row"
import Phone from "assets/images/footer/phone.svg"
import Facebook from "assets/images/footer/facebook.svg"
import Line from "assets/images/footer/line.svg"
import Instagram from "assets/images/footer/instagram.svg"
import Hotline from "assets/images/hotline/hotline_icon.svg"

import styles from "./FooterContent.module.less"
import { useTranslator } from "i18n/useTranslator"
import { FooterContentViewModel } from "./FooterContentViewModel"
import { useContainer } from "services/containerProvider"

export const FooterContent = (): JSX.Element => {
  const t = useTranslator()
  const [viewModel] = useState(new FooterContentViewModel(useContainer()))

  return (
    <Row className={styles.row} align="middle" justify="center">
      <Col sm={24} md={12}>
        <div className={styles.name}>{t("footer.organization")}</div>
        {t("footer.address")}
        <br />
        <a
          className={styles.footerLink}
          target="_blank"
          href={viewModel.getAgreementPDF()}
          rel="noreferrer">
          {t("footer.privacyPolicyFile")}
        </a>
      </Col>
      <Col sm={24} md={12} className={styles.col}>
        <Row align="middle" justify="end" gutter={[12, 8]}>
          <Col>
            <div style={{ display: "flex", alignItems: "center" }}>
              <img src={Phone} alt="Phone" style={{ width: "24px", height: "24px" }} />
              <a className={styles.footerLink} href="tel:0850422626">
                08 5042 2626
              </a>
            </div>
          </Col>
          <Col>
            <a
              className={styles.footerLink}
              target="_blank"
              href="https://www.facebook.com/chulastudentwellness"
              rel="noreferrer">
              <img src={Facebook} alt="Facebook" style={{ width: "24px", height: "24px" }} />
            </a>
          </Col>
          <Col>
            <a
              className={styles.footerLink}
              target="_blank"
              href="https://bit.ly/LineCUSW"
              rel="noreferrer">
              <img src={Line} alt="LineOA" style={{ width: "24px", height: "24px" }} />
            </a>
          </Col>
          <Col>
            <a
              className={styles.footerLink}
              target="_blank"
              href="https://www.instagram.com/cusw_official/"
              rel="noreferrer">
              <img src={Instagram} alt="Instagram" style={{ width: "24px", height: "24px" }} />
            </a>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}
